import {home} from "./src/Home";

(function (Drupal) { // closure
  'use strict';

  // Home
  Drupal.behaviors.home = home;
}(Drupal));
